import { Component, inject } from '@angular/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { FastpayInfoModalComponent } from '../fastpay-info-modal/fastpay-info-modal.component';

@Component({
  selector: 'lib-fastpay-card-cta',
  templateUrl: './fastpay-card-cta.component.html',
  styleUrls: ['./fastpay-card-cta.component.scss'],
  standalone: true,
  imports: [IonCardContent, IonButton, IonCardTitle, IonCardHeader, IonCardSubtitle, IonCard, TranslateModule],
})
export class FastpayCardCtaComponent {
  private readonly modalCtrl = inject(ModalController);

  // constructor() {}

  public async showFastpayInfoModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FastpayInfoModalComponent,
      componentProps: {
        // documentType: this.documentType,
      },
      // backdropDismiss: false,
    });
    modal.present();
  }
}
